import { apiClient } from '../services/api';
import { putRecord } from './db';

export interface CompatibilitySnapshot {
  api_version: string;
  minimum_client_version: string;
  supported_command_schemas: string[];
  supported_mapping_schema: string;
  server_time: string;
  compatible: boolean;
  checked_at: string;
}

function versionParts(value: string): number[] {
  return value.split(/[^0-9]+/).filter(Boolean).slice(0, 3).map(Number);
}
export function compareVersions(a: string, b: string): number {
  const aa = versionParts(a), bb = versionParts(b);
  for (let i=0;i<Math.max(aa.length,bb.length,3);i++) { const d=(aa[i]||0)-(bb[i]||0); if(d) return d; }
  return 0;
}

export async function checkServerCompatibility(): Promise<CompatibilitySnapshot> {
  const response = await apiClient.get('/offline/compatibility');
  const appVersion = (import.meta as any).env?.VITE_APP_VERSION || '1.5.0';
  const data = response.data;
  const compatible = compareVersions(appVersion, String(data.minimum_client_version || '0.0.0')) >= 0
    && Array.isArray(data.supported_command_schemas)
    && data.supported_command_schemas.includes('driver-gps-v1');
  const snapshot: CompatibilitySnapshot = { ...data, compatible, checked_at: new Date().toISOString() };
  await putRecord('meta', { key: 'server_compatibility', value: snapshot, updated_at: snapshot.checked_at });
  if (!compatible) localStorage.setItem('coconnect_last_offline_error', 'CLIENT_VERSION_INCOMPATIBLE');
  return snapshot;
}
